// Generated by CoffeeScript 2.7.0
var Admin__YetAnotherWorkflow__FieldsController;

import Flow from 'trunks/vue/admin/compositions/formables/flow.js';

import FlowMoreOperations from './concerns/flow_more_operations.js';

import ToggleNavMenuAction from '../toggle_nav_menu_action.js';

import {
  newConfirm
} from 'trunks/vue/admin/components/libs/confirm.js';

export default Admin__YetAnotherWorkflow__FieldsController = (function() {
  class Admin__YetAnotherWorkflow__FieldsController extends Skylark.App.BaseController {
    index() {
      var flow;
      this.__toggleNavMenu();
      flow = new Skylark.App.Model.YetAnotherWorkflow.Flow(this.getVars('flow'));
      // 最外层应用传参可用data，意味着这个东西可被改，内部组件间不能用data
      this.flow_view = new Flow({
        el: Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('yet-another-workflow_fields_container'),
        data: {
          flow: flow
        }
      });
      this.flow_view.$on('fieldLengthChanged', () => {
        return this._fieldsChanged = true;
      });
      this.flow_view.$on('flowSaved', () => {
        return this._fieldsChanged = false;
      });
      return document.body.proxy('click', '.js_save_flow', () => {
        return this.flow_view.afterValidate('save', this.flow_view.save);
      });
    }

    beforeVisit(event, action) {
      if (action === 'index' && this._fieldsChanged) {
        event.preventDefault();
        return newConfirm({
          title: '您有更改未保存， 确定要离开吗',
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).$on('ensureClicked', function() {
          return location.href = event.data.url;
        });
      }
    }

    _doRepairFlow() {}

  };

  Admin__YetAnotherWorkflow__FieldsController.include(FlowMoreOperations, ToggleNavMenuAction);

  return Admin__YetAnotherWorkflow__FieldsController;

}).call(this);
